import IconSparkles16 from '@warp-ds/icons/react/sparkles-16';
import cn from 'classnames';
import { type ReactNode, useState } from 'react';
import { SearchVerticalConfig, type Vertical } from 'shared/search/common/config';

import styles from './HeroBanner.module.css';

interface HeroBannerProps {
    vertical: Vertical;
    children?: ReactNode;
    unleash?: Record<string, boolean> | null; // cannot be just undefined as that is not serializable (toggles are returned from getSSP)
}

export const HeroBanner = ({ vertical, unleash, children }: HeroBannerProps) => {
    const [hasError, setHasError] = useState(false);

    const base = 'https://images.finncdn.no/dynamic';
    const defaultImage = `${base}/320w_webp/travel/frontpage/herobanner_${vertical}.jpg`;

    return (
        <div className={cn('', styles['hero-banner'], styles[`hero-banner--${vertical}`])}>
            {unleash?.vioWhitelabel && vertical === SearchVerticalConfig.hotel.vertical ? (
                /*
                TODO should this be used instead? The diff is the border and background colours.
                absolute w-full top-0 p-12 whitespace-nowrap pointer-events-none border border-l-4 rounded-4 s-text s-border-positive-subtle s-border-l-positive s-bg-positive-subtle  z-10
             */
                <p className="flex absolute w-full top-0 p-12 whitespace-nowrap pointer-events-none border border-l-4 rounded-4 s-text bg-[--w-color-callout-background] border-[--w-color-callout-border] z-10">
                    <span className=" mr-8  s-icon-positive">
                        <IconSparkles16 />
                    </span>
                    Heisann! Hotellsøket har nå fått ny drakt. God tur!
                </p>
            ) : null}
            <div
                className={cn(styles['hero-banner__image-wrapper'], styles[`hero-banner__image-wrapper--${vertical}`], {
                    [styles['hero-banner__image-wrapper--error']]: hasError,
                })}>
                <img
                    className={cn(styles['hero-banner__image'], styles[`hero-banner__image--${vertical}`])}
                    srcSet={`
                            ${base}/320w_webp/travel/frontpage/herobanner_${vertical}.jpg 320w,
                            ${base}/640w_webp/travel/frontpage/herobanner_${vertical}.jpg 640w,
                            ${base}/960w_webp/travel/frontpage/herobanner_${vertical}.jpg 960w,
                            ${base}/1280w_webp/travel/frontpage/herobanner_${vertical}.jpg 1280w
                        `}
                    sizes="100vw"
                    src={defaultImage}
                    onError={() => setHasError(true)}
                    alt=""
                />
            </div>
            <div className={styles['hero-banner__content-wrapper']}>{children}</div>
        </div>
    );
};
